module.exports = __webpack_public_path__ + "static/img/5.159e972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/5.png
// module id = v78M
// module chunks = 1